<div class="portion-list" *ngIf="size.portionWeightGrams">
  <div class="portion-list__col" *ngIf="nutrition && nutrition.energy">
    <div class="portion-list__item">
      <div class="portion-list__value small">
        <ng-container *ngTemplateOutlet="portionValue; context: { value: nutrition.energy, unit: size.measureUnitType, totalWeight: size.portionWeightGrams }"></ng-container>
        <span i18n="@@EnergyUnit">kcal</span>
      </div>
      <div class="portion-list__label small" i18n="@@ProductInfoEnergy">Calories</div>
    </div>
  </div>

  <div class="portion-list__col" *ngIf="nutrition && nutrition.proteins">
    <div class="portion-list__item">
      <div class="portion-list__value small">
        <ng-container *ngTemplateOutlet="portionValue; context: { value: nutrition.proteins, unit: size.measureUnitType, totalWeight: size.portionWeightGrams }"></ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
      <div class="portion-list__label small" i18n="@@ProductInfoProteins">Protein</div>
    </div>
  </div>

  <div class="portion-list__col" *ngIf="nutrition && nutrition.fats">
    <div class="portion-list__item">
      <div class="portion-list__value small">
        <ng-container *ngTemplateOutlet="portionValue; context: { value: nutrition.fats, unit: size.measureUnitType, totalWeight: size.portionWeightGrams }"></ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
      <div class="portion-list__label small" i18n="@@ProductInfoFats">Fats</div>
    </div>
  </div>

  <div class="portion-list__col" *ngIf="nutrition && nutrition.carbs">
    <div class="portion-list__item">
      <div class="portion-list__value small">
        <ng-container *ngTemplateOutlet="portionValue; context: { value: nutrition.carbs, unit: size.measureUnitType, totalWeight: size.portionWeightGrams }"></ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
      <div class="portion-list__label small" i18n="@@ProductInfoCarbs">Carb</div>
    </div>
  </div>

  <div class="portion-list__col" *ngIf="nutrition && nutrition.salt">
    <div class="portion-list__item">
      <div class="portion-list__value small">
        <ng-container *ngTemplateOutlet="portionValue; context: { value: nutrition.salt, unit: size.measureUnitType, totalWeight: size.portionWeightGrams }"></ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
      <div class="portion-list__label small" i18n="@@ProductInfoSalt">Salt</div>
    </div>
  </div>

  <div class="portion-list__col" *ngIf="nutrition && nutrition.saturatedFattyAcid">
    <div class="portion-list__item">
      <div class="portion-list__value small">
        <ng-container *ngTemplateOutlet="portionValue; context: { value: nutrition.saturatedFattyAcid, unit: size.measureUnitType, totalWeight: size.portionWeightGrams }"></ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
      <div class="portion-list__label small" i18n="@@ProductInfoSaturatedFattyAcid">SFA</div>
    </div>
  </div>

  <div class="portion-list__col" *ngIf="nutrition && nutrition.sugar">
    <div class="portion-list__item">
      <div class="portion-list__value small">
        <ng-container *ngTemplateOutlet="portionValue; context: { value: nutrition.sugar, unit: size.measureUnitType, totalWeight: size.portionWeightGrams }"></ng-container>
        <span i18n="@@WeightGramUnit">g</span>
      </div>
      <div class="portion-list__label small" i18n="@@ProductInfoSugar">Sugar</div>
    </div>
  </div>
</div>


<ng-template #portionValue let-unit="unit" let-value="value" let-totalWeight="totalWeight">
  <ng-container [ngSwitch]="unit">
    <span *ngSwitchCase="'GRAM'">{{ (value * totalWeight / 100).toFixed(1) }} </span>
    <span *ngSwitchCase="'MILLILITER'">{{ (value * totalWeight / 100).toFixed(1) }} </span>
    <span *ngSwitchCase="'KILOGRAM'">{{ (value * totalWeight * 10).toFixed(1) }} </span>
    <span *ngSwitchCase="'LITER'">{{ (value * totalWeight * 10).toFixed(1) }} </span>
  </ng-container>
</ng-template>
